import { render, staticRenderFns } from "./supercConfig.vue?vue&type=template&id=14499ec2&"
import script from "./supercConfig.vue?vue&type=script&lang=js&"
export * from "./supercConfig.vue?vue&type=script&lang=js&"
import style0 from "./supercConfig.vue?vue&type=style&index=0&id=14499ec2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports